export const isOnClimateActionDetailPage = (pathname: string): boolean =>
  /\/climate-actions\/(?!(all|dashboard|timeline|upload)(\/|$))[^/]+/.test(pathname) &&
  !pathname.includes("/teams/");
